import React from 'react'

import Layout from '../App/layout'
import ContentLayout from '../../components/utility/layoutContent'
import LayoutContentWrapper from '../../components/utility/layoutWrapper'
import CustomerFormContainer from './CustomerFormContainer'

class CustomerNewPage extends React.Component {
    componentDidMount() {
        document.title = 'Customers | OSH CRM'
    }

    render () {
        return (
            <Layout>
                <LayoutContentWrapper breadcrumbs={[
                      { path: '/customers', name: 'Customers' },
                      { path: '/customers/new', name: 'New' }
                    ]}>
                    <ContentLayout>
                      <CustomerFormContainer />
                    </ContentLayout>
                </LayoutContentWrapper>
            </Layout>
        )
    }
}

export default CustomerNewPage
